<h2>
  {{
    "settings.tax-return-alias-types"
      | transloco: { taxReturnAlias: smartFormAlias }
  }}
</h2>

<p>
  {{
    "settings.tax-return-alias-types-allow-tax-return-alias-s-to-have-different-sets-of-questions-you-may-set-up-the-question-sets-from-tax-return-alias-builder-section"
      | transloco: { taxReturnAlias: smartFormAlias }
  }}
</p>

<div class="config-row">
  <div
    class="ui toggle checkbox config-toggle"
    (click)="toggleConfigExportMode()"
  >
    <input type="checkbox" [ngModel]="configExportMode" />
    <label>{{ "settings.export-config-mode" | transloco }}</label>
  </div>
</div>

<div class="tax-return-type-filters">
  <div class="config-date">
    @if (taxYear) {
    <app-search-dropdown
      label="{{ yearLabel }}"
      [formCtrl]="taxYear"
      [listOptions]="taxYearOptions"
    ></app-search-dropdown>
    }
  </div>

  @if (configExportMode) {
  <button
    class="ui primary button background tiny"
    (click)="openConfigExportConfimationModal()"
  >
    {{ "settings.download-config" | transloco }}
  </button>
  }

  <!-- <div id="filters" *ngIf="!configExportMode">
  <app-search-dropdown
    *ngIf="taxYearOptions"
    label="{{yearLabel}}"
    [formCtrl]="taxYear"
    [listOptions]="taxYearOptions"
  ></app-search-dropdown>
</div> -->

  @if (!configExportMode) {
  <div id="keyword-filter">
    <div class="ui left icon fluid input">
      <i class="search icon"></i>
      <input
        type="text"
        [(ngModel)]="taxReturnTypeSearch"
        placeholder="Search Types"
      />
    </div>
  </div>
  } @if (!configExportMode) {
  <div class="tax-return-type-actions">
    @if (!isProductionMode) {
    <button
      class="ui primary background button tiny"
      (click)="addSmartFormType()"
    >
      {{
        "settings.add-tax-return-alias-type"
          | transloco: { taxReturnAlias: smartFormAlias }
      }}
    </button>
    }
  </div>
  } @if (!configExportMode && !isProductionMode) {
  <div
    id="create-backup"
    class="ui primary background button backup_button"
    (click)="createBackup()"
    [ngClass]="{ loading: creatingBackup }"
  >
    {{ "settings.Create-Backup" | transloco }}
  </div>
  }
</div>

@if (!filteredSmartFormTypes?.length || (smartFormTypesForConfigExport?.length
== 0 && configExportMode)) {
<div id="no-results">
  {{ "settings.no-tax-return-types-found" | transloco }}
</div>
} @if (filteredSmartFormTypes?.length && !configExportMode) {
<table class="ui striped table">
  <thead>
    <tr class="title">
      <th>{{ "settings.id" | transloco }}</th>
      <th>{{ "settings.name" | transloco }}</th>
      <th>{{ "settings.description" | transloco }}</th>
      <th>taxReturnTypeId</th>
      <th>sourceId</th>
      <th>exportable</th>
      <th>{{ "settings.Wait-for-all-smartforms-in-batch" | transloco }}</th>
      <th>{{ "settings.Lock" | transloco }}</th>
      <th></th>
      @if (!isProductionMode) {
      <th></th>
      }
    </tr>
  </thead>
  <tbody>
    @for (sft of filteredSmartFormTypes | keyWord: ['type',
    'alias']:taxReturnTypeSearch; track sft) {
    <tr>
      <td width="15%">{{ sft.id }}</td>
      <td width="15%">{{ sft.name }}</td>
      <td width="15%">{{ sft.description }}</td>
      <td width="15%" [ngClass]="{ disabled: sft.lock }">
        {{ sft.taxReturnTypeId }}
      </td>
      <td width="15%" [ngClass]="{ disabled: sft.lock }">{{ sft.sourceId }}</td>
      <td width="15%" [ngClass]="{ disabled: sft.lock }">
        {{ sft.exportable }}
      </td>
      <td width="15%" [ngClass]="{ disabled: sft.lock }">
        {{ sft.waitForAllSmartFormsInBatch }}
      </td>
      <td>
        <div
          class="ui toggle checkbox config-toggle"
          (click)="lockSmartFormTypeConfirmation(sft); $event.preventDefault()"
        >
          <input type="checkbox" [ngModel]="sft.lock" />
          <label></label>
        </div>
      </td>
      <td></td>
      @if (!isProductionMode) {
      <td
        class="edit"
        align="right"
        style="text-align: right; width: 75px;"
        (click)="editSmartFormType(sft)"
      >
        <i class="blue pen icon"></i
        ><span class="ui blue text" style="text-transform: uppercase;">{{
          "settings.edit" | transloco
        }}</span>
      </td>
      }
    </tr>
    }
  </tbody>
</table>
} @if (smartFormTypesForConfigExport?.length > 0 && configExportMode) {
<table id="list" width="100%" cellspacing="0">
  <thead>
    <tr class="title">
      <th>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="entireListSelected"
            (change)="entireListSelection()"
          /><label>&nbsp;</label>
        </div>
      </th>
      <th>{{ "settings.id" | transloco }}</th>
      <th>{{ "settings.name" | transloco }}</th>
      <th>{{ "settings.description" | transloco }}</th>
      <th>taxReturnTypeId</th>
      <th>exportable</th>
      <th>{{ "settings.Wait-for-all-smartforms-in-batch" | transloco }}</th>
      <th>{{ "settings.Lock" | transloco }}</th>
    </tr>
  </thead>
  <tbody>
    @for (sft of smartFormTypesForConfigExport | keyWord: ['type',
    'alias']:taxReturnTypeSearch; track sft) {
    <tr>
      <td>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="sft.selected"
            (change)="listSelection()"
          /><label>&nbsp;</label>
        </div>
      </td>
      <td width="15%">{{ sft.id }}</td>
      <td width="15%">{{ sft.name }}</td>
      <td width="15%">{{ sft.description }}</td>
      <td width="15%">{{ sft.taxReturnTypeId }}</td>
      <td width="15%">{{ sft.exportable }}</td>
      <td width="15%">{{ sft.waitForAllSmartFormsInBatch }}</td>
      <td width="15%">{{ sft.lock }}</td>
    </tr>
    }
  </tbody>
</table>
}

<div #configExportConfimationModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>
    {{ "settings.please-confirm-the-selected-config-to-export" | transloco }}
  </p>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>{{ "settings.name" | transloco }}</th>
        <th>{{ "settings.updated" | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (sft of selectedSmartFormTypes; track sft) {
      <tr>
        <td>{{ sft?.type.name }}</td>
        <td>{{ sft?.displayUpdatedAt }}</td>
      </tr>
      }
    </tbody>
  </table>

  @if (!selectedSmartFormTypes.length) {
  <p>{{ "settings.nothing-selected" | transloco }}</p>
  }
  <button
    class="ui primary button background tiny config-button"
    [ngClass]="{ disabled: !selectedSmartFormTypes.length }"
    (click)="downloadConfig()"
  >
    {{ "settings.download" | transloco }}
  </button>
</div>

<div
  #lockSmartFormTypeModal
  id="lock-smart-form-type-modal"
  class="ui tiny modal"
>
  <h1>{{ "settings.Warning" | transloco }}</h1>

  <div class="content">
    <p>
      {{ 'settings.Are-you-sure-to-lock-smart-form-type-{{lockedSmartFormType}}'
      | transloco : {lockedSmartFormType} }}
    </p>
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
    <div class="ui primary background button approve">
      {{ "settings.confirm" | transloco }}
    </div>
  </div>
</div>

<div
  #unlockSmartFormTypeModal
  id="unlock-smart-form-type-modal"
  class="ui tiny modal"
>
  <h1>{{ "settings.Warning" | transloco }}</h1>

  <div class="content">
    <p>
      {{ 'settings.Cannot-unlock-smart-form-type-{{lockedSmartFormType
      }}-Please-contact-support-team-for-further-assistance' | transloco :
      {lockedSmartFormType} }}
    </p>
  </div>

  <div class="actions">
    <div class="ui primary background approve button">
      {{ "settings.Close-Warnings" | transloco }}
    </div>
  </div>
</div>
